import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Avatar, { avatars, randomAvatar } from '../Avatar';
import Modal from './../../components/Modal';
import Button from '../../components/Button';
import grades from '../../common/grades';
import CircularProgress from '../../components/CircularProgress';

const defaultGrade = (
  'homepage' in window && grades.bySimpleName.has(window.homepage.currentGrade)
    ? grades.bySimpleName.get(window.homepage.currentGrade)
    : 'kindergarten'
);

const initialData = {
  name: '',
  grade: defaultGrade,
  avatar: randomAvatar()
};

function CreateChildModal(props) {
  const {
    title='Add a child',
    open=false,
    loading=false,
    error=null,
    onClose=function(){},
    onSubmit=function(){}
  } = props;

  const [data, setData] = React.useState(initialData);

  const handleClickAvatar = (avatar) => {
    setData({...data, avatar});
  };
  const handleGradeChange = (e) => {
    setData({...data, grade: e.target.value});
  };
  const handleNameChange = (e) => {
    setData({...data, name: e.target.value});
  };
  const handleSubmit = () => {
    const result = onSubmit(data);
    if(result != null && result.hasOwnProperty('then') && typeof result.then === 'function') {
      result.then(() => setData(initialData));
    }
  };

  const childAvatars = Object.keys(avatars).map((variant) => (
    <Avatar
      key={variant}
      variant={variant}
      active={variant === data.avatar}
      onClick={handleClickAvatar}
    />
  ));

  let gradesOptions= [];
  grades.GRADES.forEach(function(grade){
    gradesOptions.push(<option key={grade.simple} value={grade.simple}>{grade.abbreviated}</option>);
  });

  return (
    <Modal open={open} onClose={onClose} className="add-child-modal">
      <div className="title">{title}</div>
      <div className="modal-inner">
        <form className="form flex-container flex-wrap" onSubmit={handleSubmit}>

          <div className="form-fields">
            <div className={clsx('form-row input-row name', error && 'has-error')}>
              <label className="floating">
                <span>Child's first name</span>
                <input type="text" name="name" required value={data.name} onChange={handleNameChange} />
              </label>
              {error && (
                <p className="error">{error}</p>
              )}
            </div>
            <div className="form-row input-row grade">
              <label className="floating not-empty">
                <span>Choose grade level</span>
                <select name="grade" value={data.grade} onChange={handleGradeChange}>
                  {gradesOptions}
                </select>
              </label>
            </div>
          </div>

          <div className="avatars-preview-all">
            <div className="avatars-container flex-container flex-wrap">
              {childAvatars}
            </div>
          </div>

          <div className="btn-container">
            <Button size="large" color="secondary" onClick={onClose}>Cancel</Button>
            <Button size="large" color="primary" onClick={handleSubmit} disabled={loading}>
              {loading && (<CircularProgress color="brand" />)}
              Add child
            </Button>
          </div>

        </form>
        <div className="loading"/>
      </div>
    </Modal>
  );
}

CreateChildModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func
};

export default CreateChildModal;
